import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHead, Modal, Field, inp } from "../../components/admin/AdminBits";
import RichEditor from "../../components/RichEditor";
import { Plus, Pencil, Trash2, FileText, ExternalLink } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { title: "", slug: "", content: "", seo_title: "", seo_description: "", seo_keywords: "", published: true, in_footer: false, order: 99 };

export default function AdminPages() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/pages").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try { if (edit.id) await api.put(`/admin/pages/${edit.id}`, edit); else await api.post("/admin/pages", edit); toast.success("Запазено"); setEdit(null); load(); }
    catch { toast.error("Грешка"); }
  };
  const del = async (id) => { if (window.confirm("Изтриване?")) { await api.delete(`/admin/pages/${id}`); load(); } };

  return (
    <div data-testid="admin-pages">
      <PageHead title="Страници" desc="Статичните страници (Начало, За автора, Контакти) са вградени. Тук създавате динамични страници с пълен едитор и SEO."
        action={<button onClick={() => setEdit({ ...EMPTY })} className="btn-gold px-4 py-2.5 rounded-sm text-sm flex items-center gap-2" data-testid="add-page-btn"><Plus size={16} /> Нова страница</button>} />
      <div className="bg-white border border-stone overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-stone text-navy"><tr><th className="text-left p-3">Заглавие</th><th className="text-left p-3">URL</th><th className="text-left p-3">Footer</th><th className="text-left p-3">Статус</th><th className="p-3"></th></tr></thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-t border-stone" data-testid={`page-${p.slug}`}>
                <td className="p-3 text-navy font-medium flex items-center gap-2"><FileText size={14} className="text-gold" />{p.title}</td>
                <td className="p-3"><a href={`/stranitsa/${p.slug}`} target="_blank" rel="noreferrer" className="text-gold hover:underline flex items-center gap-1">/{p.slug} <ExternalLink size={11} /></a></td>
                <td className="p-3">{p.in_footer ? "Да" : "—"}</td>
                <td className="p-3">{p.published ? <span className="text-green-600">Публикувана</span> : <span className="text-charcoal/40">Чернова</span>}</td>
                <td className="p-3 text-right"><div className="flex justify-end gap-2"><button onClick={() => setEdit(p)} className="text-navy hover:text-gold"><Pencil size={15} /></button><button onClick={() => del(p.id)} className="text-charcoal/40 hover:text-red-500"><Trash2 size={15} /></button></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && (
        <Modal title={edit.id ? "Редакция на страница" : "Нова страница"} onClose={() => setEdit(null)} wide>
          <form onSubmit={save}>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Заглавие"><input required value={edit.title} onChange={(e) => setEdit({ ...edit, title: e.target.value })} className={inp} data-testid="page-title" /></Field>
              <Field label="URL (slug)"><input value={edit.slug} onChange={(e) => setEdit({ ...edit, slug: e.target.value })} className={inp} placeholder="auto" /></Field>
            </div>
            <Field label="Съдържание"><RichEditor value={edit.content} onChange={(v) => setEdit({ ...edit, content: v })} /></Field>
            <div className="grid grid-cols-2 gap-3 mt-3">
              <Field label="SEO заглавие"><input value={edit.seo_title} onChange={(e) => setEdit({ ...edit, seo_title: e.target.value })} className={inp} /></Field>
              <Field label="SEO ключови думи"><input value={edit.seo_keywords} onChange={(e) => setEdit({ ...edit, seo_keywords: e.target.value })} className={inp} /></Field>
            </div>
            <Field label="SEO описание"><textarea value={edit.seo_description} onChange={(e) => setEdit({ ...edit, seo_description: e.target.value })} rows={2} className={inp} /></Field>
            <div className="flex gap-6">
              <label className="flex items-center gap-2 text-sm text-navy"><input type="checkbox" checked={edit.published} onChange={(e) => setEdit({ ...edit, published: e.target.checked })} className="accent-[#C6A45C]" /> Публикувана</label>
              <label className="flex items-center gap-2 text-sm text-navy"><input type="checkbox" checked={edit.in_footer} onChange={(e) => setEdit({ ...edit, in_footer: e.target.checked })} className="accent-[#C6A45C]" /> Показвай във footer</label>
            </div>
            <button type="submit" className="btn-gold w-full py-2.5 rounded-sm mt-4" data-testid="save-page-btn">Запази</button>
          </form>
        </Modal>
      )}
    </div>
  );
}
